/**
 * Onboarding shortlists.
 *
 * These are SLUGS only, deliberately. The reference tables (`cuisines`,
 * `allergens`, `dietary_profiles`) are server-owned, and so are their primary
 * keys: a hardcoded id here silently drifts from the row it names and the
 * foreign key on `user_cuisine_preferences` rejects the write with an opaque
 * 500. Slugs are the stable public handle, so consumers resolve slug -> id from
 * the reference API at runtime (see `useSetupFacetOptions`). A slug with no
 * matching row is dropped rather than rendered.
 *
 * Order is the curated presentation order and is preserved by the resolver.
 */

/** Onboarding shortlist: broad favorite-cuisine options. */
export const ONBOARDING_CUISINE_SLUGS = [
  'italian',
  'mexican',
  'japanese',
  'chinese',
  'thai',
  'indian',
  'american',
  'mediterranean',
  'korean',
  'vietnamese',
  'french',
  'middle-eastern',
] as const;

/** Onboarding shortlist: the FDA "big nine" allergens. */
export const ONBOARDING_ALLERGEN_SLUGS = [
  'milk',
  'eggs',
  'fish',
  'shellfish',
  'tree_nuts',
  'peanuts',
  'wheat',
  'soybeans',
  'sesame',
] as const;

/** Onboarding shortlist: common dietary profiles. */
export const ONBOARDING_DIETARY_SLUGS = [
  'vegetarian',
  'vegan',
  'pescatarian',
  'gluten_free',
  'dairy_free',
  'halal',
  'kosher',
] as const;
